<input type="checkbox" id="nav-toggle" [(ngModel)]="toggle">
<div class="sidebar">
  <div class="sidebar-brand">
    <img src="assets/img/logo.png" alt="Logo Comp online" class="logo"><h6><span>COMPROBANTES <br> ONLINE</span></h6>
  </div>

  <div class="sidebar-menu">
    <ul>
      <li class="active">
        <mat-icon class="icon">account_circle</mat-icon>
         <span>{{nombre}}</span>

        <div class="icons">
          <a routerLink="/login" routerLinkActive="activo" matTooltip="Editar perfil" (click)="logout()" matTooltip="Cerrar sesión">
          <mat-icon class="icon"  (click)="logout()" matTooltip="Cerrar sesión">input</mat-icon>
          </a>
          <a routerLink="/home/settings" (click)="escMenu()" routerLinkActive="activo" matTooltip="Editar perfil">
            <mat-icon class="icon ispace">settings</mat-icon>
          </a>
        </div></li>

        <li routerLink="/home/facturas" (click)="escMenu()"  routerLinkActive="activo"  *ngIf="verFacturas">
          <a routerLink="/home/facturas"  routerLinkActive="activo">
          <mat-icon class="icon">description</mat-icon> <span>Facturas</span>
          </a>
        </li>

          <li routerLink="/home/op" (click)="escMenu()" routerLinkActive="activo" *ngIf="verOrdenes">
            <a routerLink="/home/op" routerLinkActive="activo">
            <mat-icon class="icon">paid</mat-icon> <span>Órdenes de pago</span>
            </a></li>

          @if(HABILITAR_PANTALLA_OC_PENDIENTE){
            
          <li routerLink="/home/proveedores/carga-fc" (click)="escMenu()" routerLinkActive="activo"  *ngIf="verOrdenes">
            <a routerLink="/home/proveedores/carga-fc" routerLinkActive="activo">
            <mat-icon class="icon">upload</mat-icon> <span>Órdenes de compra pendientes</span>
            </a>
          </li>

          }


          @if(HABILITAR_MENU_COMPROBANTES_PROVEEDORES){
            
            <li routerLink="/home/facturas-proveedor" (click)="escMenu()" routerLinkActive="activo"  *ngIf="verOrdenes">
              <a routerLink="/home/facturas-proveedor" routerLinkActive="activo">
              <mat-icon class="icon">receipt</mat-icon> <span>Comprobantes proveedor</span>
              </a>
            </li>
  
            }
  

          </ul>
          
          <div class="side-footer">
              <a href="https://rpsistemas.com.ar/" target="_blank">
              <img src="assets/img/favicon.ico" alt="">
              <span>Desarrollado por RP Sistemas</span>
            </a>
          </div>
  </div>
</div>


<div class="main-content">
  <header>
    <div class="header-title">
      <h2>
        <label for="nav-toggle">
          <mat-icon class="icon">chevron_left</mat-icon>
        </label>
      </h2>
    </div>

        <div class="user-wrapper">
          <button *ngIf="HABILITAR_BOTON_SUBIR_PDF" (click)="abrirModalSubir()" class="bg-white flex items-center text-primario p-2 rounded-md mr-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-base w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            <span  class="!text-primario text-sm ml-2">Subir PDF</span>            
          </button>
            <span>{{razon}}</span>
    </div>
  </header>

  <!-- Modal para subir PDFs -->
  <app-modal-subir-pdf 
  *ngIf="mostrarModal" 
  (cerrar)="cerrarModal()" 
  (facturasSubidas)="onFacturasSubidas()"
  (mostrarAlerta)="onMostrarAlerta($event)">
  </app-modal-subir-pdf>

  <!-- aca se muestran los componentes que estan dentro del children-->
  <router-outlet></router-outlet>
</div>
<app-alert-modal
*ngIf="modalConfig.show"
[type]="modalConfig.type"
[title]="modalConfig.title"
[message]="modalConfig.message"
[confirmText]="modalConfig.confirmText"
[showCancel]="modalConfig.showCancel"
(confirm)="modalConfig.onConfirm()"
(cancel)="onAlertModalClose()">
</app-alert-modal>
